// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconLayoutBoard, IconAdjustmentsHorizontal, IconWand } from '@tabler/icons';

// constant
const icons = {
    IconLayoutBoard,
    IconAdjustmentsHorizontal,
    IconWand
};

// ==============================|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||============================== //

const aiTools = {
    id: 'ai-tool',
    title: null,
    type: 'group',
    children: [
        {
            id: 'creator',
            title: <FormattedMessage id="ai-smart-creator" />,
            type: 'item',
            baseurl: '/creator',
            icon: icons.IconWand,
            breadcrumbs: false
        }
    ]
};

export default aiTools;
